import CustomSelectButton from './CustomSelectButton';
import React, { useState } from 'react';
import { INDEX } from '../../../../constants/driveglobalfilterinitalstates';
import styles from './overview.module.css'


export default function Filter(props) {
  const [columnfilters, setcolumnfilters] = useState([]);
  const [changedColumn, setChangedColumn] = useState("");

  const updateFilter = (arr, index) => {
    let state_ind = INDEX[index];

    // Update parent Overview state directly
    props.onsubmit((prev) => ({ ...prev, [state_ind]: arr }));
    setChangedColumn(index);

    // Track applied column filters
    if (columnfilters.indexOf(index) === -1) {
      setcolumnfilters([...columnfilters, index]);
    }
  };



  return (
    <>
      <div className="card mb-3 p-3 w-100">
        <div className="row">


          <div className="col-md-3">

            <CustomSelectButton
              lable="Select City"
              IND="CITY_INDEX"
              filterdata={props.gloablfilter}
              columnfilters={columnfilters}
              apiEnd="city"
              updateFilter={updateFilter}
            />
          </div>


          <div className="col-md-3">

            <CustomSelectButton
              lable="Select Depo"
              IND="DEPO_INDEX"
              filterdata={props.gloablfilter}
              columnfilters={columnfilters}
              apiEnd="depo"
              updateFilter={updateFilter}
            />
          </div>
        </div>
      </div>
    </>
  )
}


